/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse403,
    InlineResponse403FromJSON,
    InlineResponse403ToJSON,
    ProductTag,
    ProductTagFromJSON,
    ProductTagToJSON,
    ProductTagDataFrame,
    ProductTagDataFrameFromJSON,
    ProductTagDataFrameToJSON,
} from '../models';

export interface ApiProductTagsGetRequest {
    relations?: string;
    deleted?: boolean;
    filtering?: string;
    offset?: number;
    limit?: number;
    order?: string;
}

export interface ApiProductTagsIdDeleteRequest {
    id: number;
}

export interface ApiProductTagsIdGetRequest {
    id: number;
    relations?: string;
    deleted?: boolean;
}

export interface ApiProductTagsPostRequest {
    relations?: string;
    deleted?: boolean;
    productTag?: ProductTag;
}

/**
 * no description
 */
export class ProductTagApi extends runtime.BaseAPI {

    /**
     * Get list of ProductTag
     */
    async apiProductTagsGetRaw(requestParameters: ApiProductTagsGetRequest): Promise<runtime.ApiResponse<ProductTagDataFrame>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        if (requestParameters.filtering !== undefined) {
            queryParameters['filtering'] = requestParameters.filtering;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/productTags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductTagDataFrameFromJSON(jsonValue));
    }

    /**
     * Get list of ProductTag
     */
    async apiProductTagsGet(relations?: string, deleted?: boolean, filtering?: string, offset?: number, limit?: number, order?: string): Promise<ProductTagDataFrame> {
        const response = await this.apiProductTagsGetRaw({ relations: relations, deleted: deleted, filtering: filtering, offset: offset, limit: limit, order: order });
        return await response.value();
    }

    /**
     * Remove entity of ProductTag
     */
    async apiProductTagsIdDeleteRaw(requestParameters: ApiProductTagsIdDeleteRequest): Promise<runtime.ApiResponse<ProductTag>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiProductTagsIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/productTags/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductTagFromJSON(jsonValue));
    }

    /**
     * Remove entity of ProductTag
     */
    async apiProductTagsIdDelete(id: number): Promise<ProductTag> {
        const response = await this.apiProductTagsIdDeleteRaw({ id: id });
        return await response.value();
    }

    /**
     * Get entity of ProductTag
     */
    async apiProductTagsIdGetRaw(requestParameters: ApiProductTagsIdGetRequest): Promise<runtime.ApiResponse<ProductTag>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiProductTagsIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/productTags/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductTagFromJSON(jsonValue));
    }

    /**
     * Get entity of ProductTag
     */
    async apiProductTagsIdGet(id: number, relations?: string, deleted?: boolean): Promise<ProductTag> {
        const response = await this.apiProductTagsIdGetRaw({ id: id, relations: relations, deleted: deleted });
        return await response.value();
    }

    /**
     * Create or update entity of ProductTag (if id defined)
     */
    async apiProductTagsPostRaw(requestParameters: ApiProductTagsPostRequest): Promise<runtime.ApiResponse<ProductTag>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/productTags`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductTagToJSON(requestParameters.productTag),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductTagFromJSON(jsonValue));
    }

    /**
     * Create or update entity of ProductTag (if id defined)
     */
    async apiProductTagsPost(relations?: string, deleted?: boolean, productTag?: ProductTag): Promise<ProductTag> {
        const response = await this.apiProductTagsPostRaw({ relations: relations, deleted: deleted, productTag: productTag });
        return await response.value();
    }

}
